"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22
  }, props), __jsx("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, __jsx("path", {
    d: "M.688 7.563L11 .688l10.313 6.875M2.063 17.188h17.875v4.125H2.063v-9.625",
    strokeWidth: 1.191671
  }), __jsx("path", {
    d: "M4.813 13.063h-2.75v4.124h5.5v-1.375a2.75 2.75 0 00-2.75-2.75zM17.188 13.063h-4.326a4.125 4.125 0 00-3.69 2.28l-.922 1.845h11.688v-1.375a2.75 2.75 0 00-2.75-2.75z",
    strokeWidth: 1.191671
  })));
}
var _default = exports.default = SvgComponent;